import type { SVGProps } from 'react';

const Key = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 8.83335C11.5648 8.83335 12.8333 7.56482 12.8333 6.00002C12.8333 4.43521 11.5648 3.16669 10 3.16669C8.43521 3.16669 7.16667 4.43521 7.16667 6.00002C7.16667 6.20677 7.18881 6.40834 7.23087 6.6025L3.16667 10.6667V12.8334H5.33334L5.83334 12.3334V11.1667H7.00001L7.83334 10.3334V9.16669H9.00001L9.39754 8.76915C9.59167 8.81122 9.79327 8.83335 10 8.83335Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 5.33333C11 5.51743 10.8507 5.66667 10.6667 5.66667C10.4826 5.66667 10.3333 5.51743 10.3333 5.33333C10.3333 5.14924 10.4826 5 10.6667 5C10.8507 5 11 5.14924 11 5.33333Z"
      stroke="currentColor"
      strokeWidth="0.666667"
    />
  </svg>
);

export default Key;
